/**
 * Development/test keypair for the FHIR API.
 *
 * The **public key** is seeded into the `fhir_api_clients` table so that
 * the token endpoint can verify client assertions signed with the private key.
 *
 * The **private key** is used by the interactive FHIR Explorer page (and
 * integration tests) to sign client_assertion JWTs when obtaining tokens.
 *
 * ⚠️  This keypair is for local development and test environments only.
 *     Production clients generate their own keypairs and register the public
 *     key via the admin API.
 *
 * The private key `d` component is loaded from the FHIR_DEV_PRIVATE_JWK_D
 * environment variable (never committed to the repo). For local dev, set this
 * in your `.env` file. An empty string is used as a fallback so that the
 * module loads without error in environments where the key is not needed.
 */
export const FHIR_DEV_CLIENT_ID = "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d";
/**
 * A second dev client, registered against the same keypair but entitled to one
 * ICB rather than both. It exists so the explorer can demonstrate organisation
 * scoping: the same patient, queried as each client, returns a different slice
 * of the same detention. Sharing the keypair keeps the difference to the one
 * thing being demonstrated.
 */
export const FHIR_DEV_NARROW_CLIENT_ID = "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e";
export const FHIR_DEV_PRIVATE_JWK = {
    kty: "EC",
    x: "bjUsWZ70j9dG9k9v569cMiWoBUP-LnaC5I6kZA7A5fw",
    y: "2x33NzC6xI9Vuvz8TW8c0WAo4Su9pB4xf-mQAmadLBA",
    crv: "P-256",
    d: (typeof process !== "undefined"
        ? process.env.FHIR_DEV_PRIVATE_JWK_D
        : undefined) ?? "",
    kid: "fhir-dev-key-1",
};
export const FHIR_DEV_PUBLIC_JWKS = {
    keys: [
        {
            kty: "EC",
            x: "bjUsWZ70j9dG9k9v569cMiWoBUP-LnaC5I6kZA7A5fw",
            y: "2x33NzC6xI9Vuvz8TW8c0WAo4Su9pB4xf-mQAmadLBA",
            crv: "P-256",
            kid: "fhir-dev-key-1",
            use: "sig",
            alg: "ES256",
        },
    ],
};
//# sourceMappingURL=fhirDevKeys.js.map